export interface KanbanMemberSelectorUserModel {
  firstName: string | null,
  lastName: string | null,
  displayName: string | null,
  userId: string,
  isBoardAdmin: boolean
}

export const UNASSIGNED_MEMBER_ID_VALUE: string = 'Unassigned'
